export default class SnowflakeLastRunDto {
  constructor(options = {}) {
    this.lastRunStatus = options.lastRunStatus || ''; 
  }
}
